import { Table } from '@tanstack/react-table';
import { TableBody } from '@/components/ui/table';
import type { DataTableRow, TableAction } from '../types';
import { DataTableRow as TableRowComponent } from './data-table-row';

interface SimpleTableBodyProps<T extends DataTableRow> {
  table: Table<T>;
  selectable?: boolean;
  actions?: TableAction<T>[];
}

export function SimpleTableBody<T extends DataTableRow>({
  table,
  selectable = false,
  actions = []
}: SimpleTableBodyProps<T>) {
  return (
    <TableBody>
      {table.getRowModel().rows.map((row) => (
        <TableRowComponent key={row.id} row={row} selectable={selectable} actions={actions} />
      ))}
    </TableBody>
  );
}
